module.exports = __webpack_public_path__ + "static/img/logo_test.ba793dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_test.png
// module id = 36rG
// module chunks = 52